import { ref } from 'vue';

const loading = ref(false)

export function useApp() {
  return {
    loading
  }
}
